import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as AuthApiActions from '../auth/actions/auth-api.actions';
import * as AuthActions from '../auth/actions/auth.actions';
import * as SigninPageActions from '../auth/actions/signin-page.actions';
import { environment } from '../../../environments/environment';

export interface State { }

export const reducers: ActionReducerMap<State> = { };

export const metaReducers: MetaReducer<State>[] = [clearState];

/** Every action that ends a user's session in this tab. `autoLogout` is a switch of user by URL. */
const sessionEndingActions: string[] = [
  AuthApiActions.logoutSuccess.type,
  AuthApiActions.logoutFailure.type,
  SigninPageActions.autoLogout.type,
  SigninPageActions.signin.type,
  AuthActions.setUser.type,
];

/** The slices that hold the user's data. `auth` is left to its own reducer. */
const userSlices = ['unit', 'reportState', 'zones', 'coreState', 'userAccountsState', 'fuel', 'mapDraw'];

/** Caches the reducers start from. */
const cachedKeys = ['cachedUnits', 'cachedUnitGroups', 'cachedPositions', 'cachedCustomValues',
  'cachedSettings', 'cachedRegions', 'cachedZonesSubscriptions', 'cachedZoneGroups'];

export function clearState(reducer) {
  return function (state, action) {
    const scopeChanged = action?.type === AuthApiActions.sessionRefreshSuccess.type && action.scopeChanged === true;

    if (state && (sessionEndingActions.includes(action.type) || scopeChanged)) {
      // Clear persisted cache BEFORE resetting NgRx state — the state reset makes each reducer call
      // getInitialState(), which reads from localStorage. If old data is still there at that point
      // it would leak into the new session.
      const prefix = environment.storagePrefix;
      cachedKeys.forEach(k => localStorage.removeItem(`${prefix}.${k}`));

      state = { ...state };
      userSlices.forEach(slice => state[slice] = undefined);
    }

    return reducer(state, action);
  };
}
